import { Layout, PostListWidgetPaginationType } from '@wix/communities-blog-client-common';

export const LAYOUT_TYPE_AI_DESCRIPTION = `
The layout type for the blog feed page.
Possible values:
- ${Layout.PgSideBySide} Image on one side, content on the other side.
- ${Layout.PgGrid} Grid layout.
- ${Layout.PgCardMedium} Tiled layout where each card has it's own size.
- ${Layout.PgTextOnImageMedium} Magazine layout where text is on the image.
- ${Layout.PgOneColumn} One column layout.
`;

export const PAGINATION_TYPE_AI_DESCRIPTION = `
        The pagination type for the post list widget.
        Possible values:
        - ${PostListWidgetPaginationType.NumberOfPosts} Displays only a number of posts.
        - ${PostListWidgetPaginationType.Paginated} Displays a number of posts per page.
        `;
